import React, { Component } from 'react';
import { Form, Input, Row, Col } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { isValidArray } from 'src/Library/Helper';
import useField, { useFieldProps } from 'src/hooks/form/useField';
import useInput from 'src/hooks/form/useInput';
import useMultiField from 'src/hooks/form/useMultiField';
import FieldNodeSingle from './FieldNodeSingle';
import { FieldNodeProps } from './form.types';

export type FieldNodeMultiRef = {
  field: any; //ReturnType<typeof useMultiField>;
  // children: React.ReactElement;
};

const FieldNodeMulti = (renderComponent, values?: any[]) =>
  React.forwardRef<FieldNodeMultiRef, FieldNodeProps & { requestRerender: () => void }>(
    ({ children, requestRerender, ...props }, ref) => {
      const field = useMultiField({
        defaultNode: {
          renderComponent,
          renderProps: props,
        },
        requestRerender,
        defaultValues: values,
      });

      if (ref) {
        (ref as any).current = { field };
      }

      return <>{children}</>;
      // return <>{field.render(render)}</>;
    }
  );

export default FieldNodeMulti;
